import React from 'react';
import SkeletonLoader from 'Douleutaras/components/Loaders/SkeletonLoader';

import './ProCleanerAttributesLoader.scss';

const ProCleanerAttributesLoader = () => {
  return (
    <>
      <ul styleName="attributes">
        <li styleName="attributes__item">
          <SkeletonLoader type="circle" width={24} height={24} />
          <span styleName="attributes__text">
            <SkeletonLoader type="line" width={140} />
          </span>
        </li>
      </ul>
      <ul styleName="attributes">
        <li styleName="attributes__item">
          <SkeletonLoader type="circle" width={24} height={24} />
          <span styleName="attributes__text">
            <SkeletonLoader type="line" width={140} />
          </span>
        </li>
        <li styleName="attributes__item">
          <SkeletonLoader type="circle" width={24} height={24} />
          <span styleName="attributes__text">
            <SkeletonLoader type="line" width={120} />
          </span>
        </li>
        <li styleName="attributes__item">
          <SkeletonLoader type="circle" width={24} height={24} />
          <span styleName="attributes__text">
            <SkeletonLoader type="line" width={140} />
          </span>
        </li>
      </ul>
    </>
  );
};

export default ProCleanerAttributesLoader;
